import { HomeSliceType, SliderHeroSlice } from '../../../../types/slice';
import homeTile from './home-tile';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const sliderHeroSlice = (data: Record<string, any>): SliderHeroSlice => {
  if (data.primary?.enabled !== 'oui') {
    return undefined;
  }

  return {
    type: HomeSliceType.SLIDER_HERO,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    slides: data.items.map((slide: any) => homeTile(slide)),
  };
};

export default sliderHeroSlice;
